import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { RelativeRelationshipCode } from '../../../../../core';

@JsonConverter
export class RelativeRelationshipCodeAdapter implements JsonCustomConvert<RelativeRelationshipCode | undefined> {
    serialize(code: RelativeRelationshipCode): any | undefined {
        return code ? String(code) : undefined;
    }

    deserialize(code: any): RelativeRelationshipCode | undefined {
        switch (code) {
            case 'HR':
                return RelativeRelationshipCode.BROTHER;
            case 'PD':
                return RelativeRelationshipCode.FATHER;
            case 'AL':
                return RelativeRelationshipCode.RELATED;
            case 'HJ':
                return RelativeRelationshipCode.SON;
            case 'CY':
                return RelativeRelationshipCode.SPOUSE;
            default:
                return undefined;
        }
    }
}
